export const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID || "1");
export const API_URL = process.env.REACT_APP_API_URL as string;
export const RPC_URL = process.env.REACT_APP_RPC_URL as string;
